import React from 'react';
// import Joyride from 'react-joyride';
import { PostVenditaSection, ActionButton } from './SelectPostVenditaAction.styles';
import AfterSalesList from './AfterSalesList/AfterSalesList';
// import { useTourContext } from '../context/useTourContext';
// import { joyrideOptions } from '../common/utils/joyrideUtils';
// import { handleCallbackPostVenditaAction } from '../common/utils/joyrideCallbacks';
// import { selectPostVenditaSteps } from '../common/utils/joyrideSteps';

function SelectPostVenditaAction() {
  return (
    <>
      <PostVenditaSection className="container mt-5 mb-4">
        {/* <Joyride
          steps={selectPostVenditaSteps}
          continuous
          showBeacon={showBeacon}
          locale={{
            back: 'Indietro',
            close: 'Chiudi',
            last: 'Fine',
            next: 'Prossima',
            open: 'Apri il modale',
            restart: 'Riavvia il tour ',
            skip: 'Salta',
          }}
          styles={{
            options: joyrideOptions,
            buttonNext: {
              backgroundColor: '#00a651',
              outline: 'none',
            },
            buttonBack: {
              color: '#00a651',
              outline: 'none',
            },
            beaconInner: {
              backgroundColor: '#00a651',
            },
            beaconOuter: {
              borderColor: '#00a651',
              backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
            },
            buttonSkip: {
              outline: 'none',
            },
            buttonClose: {
              outline: 'none',
            },
            overlay: {
              height: '100vh',
            },
          }}
          run={run}
          callback={(data) => { handleCallbackPostVenditaAction(data, selectPostVenditaSteps, setState); }}
          showSkipButton
          showProgress
        />
        {localStorage.getItem('postVendita') === 'done' && (
          <div style={{ cursor: 'pointer', top: '8%' }} onClick={() => fireNewQuoteTour()} className="position-fixed end-0 mt-1 me-3">
            <button className="btn btn-success px-2 py-1 rounded-3">Tutorial</button>
          </div>
        )} */}
        <div className="page-header">
          <h2>🎯 Cosa Vuoi Fare?</h2>
        </div>

        <hr />

        <div className="actions-container">
          <ActionButton
            to="/after-sale"
            className="post-vendita-one"
          >
            📝 Apri Nuovo Ticket
          </ActionButton>
          <ActionButton
            to="/after-sale/select"
            className="post-vendita-two"
          >
            ⚙️ Gestisci
          </ActionButton>
        </div>
      </PostVenditaSection>
      <AfterSalesList className="mt-4" />
    </>
  );
}

export default SelectPostVenditaAction;
